





















































































import { Component, Prop, Vue } from "vue-property-decorator";

import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { mapState } from "vuex";

@Component({
  components: {
    IconUserImage,
    PointNotation,
    TextLabel,
    SmallText,
    IconInvestedRounded
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode
    })
  }
})
export default class H01PointConfirmItem extends Vue {
  @Prop({ type: [String, Boolean], default: false }) iconPath!:
    | string
    | boolean;
  @Prop({ type: Boolean, default: false }) unread!: boolean;
  @Prop({ type: [String, Boolean], default: false }) name!: string | boolean;
  @Prop({ type: String }) date!: string;
  @Prop({ type: [String, Boolean], default: false }) status!: string | boolean;
  @Prop({ type: String, required: true }) usage!: string;
  @Prop({ type: [String, Boolean], default: false }) label!: string | boolean;
  @Prop({ type: [String, Boolean], default: false }) labelType!:
    | string
    | boolean;
  @Prop({ type: [String, Boolean], default: false }) group!: string | boolean;
  @Prop({ type: [String, Boolean], default: false }) group_code!:
    | string
    | boolean;
  @Prop({ type: [Number, Boolean], default: false }) point!: number | boolean;

  @Prop({ type: Boolean, default: false }) sign!: boolean;
  @Prop({ type: String, required: true }) url!: string;
  @Prop({ type: [String, Boolean], default: false }) approved!:
    | string
    | boolean;
  @Prop({ type: Boolean, default: false }) approvedEnabled!: boolean;
  @Prop({ type: [Number, Boolean], default: false }) iconType!:
    | number
    | boolean;
  storeColorCode: string;

  get unit() {
    return commons?.unit;
  }

  get customizeColor() {
    return commons?.storeColorCode;
  }

  get isSp() {
    return globals?.isLargeBreakpointWidthOfSp;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

  get pointNotationStyle() {
    const pointNotationStyle = {
      sp: {
        fontSize: 18
      },
      pc: {
        fontSize: 24
      }
    };
    const index = this.isSp ? "sp" : "pc";

    return pointNotationStyle[index];
  }

  get reverseLabelColor() {
    const { labelType } = this;
    let reverse = false;

    switch (labelType) {
      case "thanks":
        reverse = true;
        break;

      case "distribution":
        reverse = false;
        break;
    }

    return reverse;
  }
}
